import {
  type SelectArrayInputProps,
  SelectArrayInput,
  useGetList,
} from "react-admin";

import { type ModuleValue } from "@/types/modules";

type Props = Omit<SelectArrayInputProps, "resource"> & {
  module: ModuleValue;
};

const STALE_TIME = 60_000;

export const ReferenceSelectArrayInput = ({ module, ...rest }: Props) => {
  const { isPending, data } = useGetList(
    module,
    { sort: { field: "id", order: "ASC" } },
    {
      staleTime: STALE_TIME,
    },
  );

  return (
    <SelectArrayInput {...rest} isPending={isPending} choices={data ?? []} />
  );
};
